"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyUser = void 0;
const constants_1 = require("@framework/constants");
const types_1 = require("@framework/types");
const empty_address_1 = require("./empty-address");
const date = new Date();
exports.emptyUser = {
    password: "",
    confirm: "",
    email: "",
    displayName: "",
    language: constants_1.EnabledLanguages.EN,
    imageUrl: "",
    userStatus: types_1.UserStatus.ACTIVE,
    userRoles: [],
    addresses: [empty_address_1.emptyAddress],
    createdAt: date.toISOString(),
};
//# sourceMappingURL=empty-user.js.map